import { Flex, InlineList, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { CourseService } from "../../../services/CourseService";
import { RefreshMetricsContext } from "../../../views/Outcomes";
import { ERROR, useNotification } from "../../CustomHooks/NotificationProvider";

const OutcomeData = ({ reload, setReload, subject, searchTrigger }) => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const { refreshMetrics, setRefreshMetrics } = useContext(
    RefreshMetricsContext
  );
  const [qualityCalculated, setQualityCalculated] = useState(false);
  const [highQualPercentage, setHighQualPercentage] = useState(0);
  const [unapprovedCount, setUnapprovedCount] = useState(0);
  const [prevSubject, setPrevSubject] = useState("");

  useEffect(() => {
    if ((reload || searchTrigger) && subject && subject !== prevSubject) {
      setQualityCalculated(false);
      setPrevSubject(subject);

      CourseService.getQualityMetrics(subject)
        .then((quality) => {
          setUnapprovedCount(quality.unapproved);
          setHighQualPercentage(quality.quality_percentage);
        })
        .catch((error) => {
          showNotification(
            `${t("notifications.dashboard.qualityCalculationError")}: ${
              error.statusText
            }`,
            ERROR
          );
        })
        .finally(() => {
          setQualityCalculated(true);
          setReload(false);
        });
    }
  }, [searchTrigger, reload, subject, showNotification]);

  useEffect(() => {
    if (refreshMetrics) {
      CourseService.getQualityMetrics(subject)
        .then((quality) => {
          setUnapprovedCount(quality.unapproved);
          setHighQualPercentage(quality.quality_percentage);
        })
        .catch((error) => {
          showNotification(
            `${t("notifications.dashboard.qualityCalculationError")}: ${
              error.statusText
            }`,
            ERROR
          );
        })
        .finally(() => {
          setRefreshMetrics(false);
        });
    }
  }, [refreshMetrics]);

  return (
    <Flex wrap="wrap" justifyItems="end">
      <Flex.Item>
        {qualityCalculated && (
          <InlineList delimiter="pipe">
            <InlineList.Item>
              <Text weight="bold">
                {prevSubject + t("dashboard.outcomeQuality")}:{" "}
                {Math.ceil(highQualPercentage) + "%"}
              </Text>
            </InlineList.Item>
            <InlineList.Item>
              <Text weight="bold">
                {t("dashboard.unapprovedOutcomes")}: {unapprovedCount}
              </Text>
            </InlineList.Item>
          </InlineList>
        )}
      </Flex.Item>
    </Flex>
  );
};

export default OutcomeData;
